import { Link } from 'react-router';

export default function NotFoundPage() {
  return (
    <div className="size-full bg-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="font-['Playfair_Display',sans-serif] font-extrabold leading-[48px] text-[#8e2a2f] text-[34px] tracking-[-0.0944px] mb-4">
          404 - Page Not Found
        </h1>
        <p className="font-['DM_Sans',sans-serif] font-normal leading-[21px] text-[#908e8e] text-[14px] tracking-[-0.1px] mb-6" style={{ fontVariationSettings: "'opsz' 14" }}>
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          className="inline-block h-[54px] px-8 bg-[#8e2a2f] hover:bg-[#7a2428] transition-colors rounded-[10px] cursor-pointer"
        >
          <p className="font-['DM_Sans',sans-serif] font-bold leading-[54px] text-white text-[14px] tracking-[-0.1px]" style={{ fontVariationSettings: "'opsz' 14" }}>
            Go Home
          </p>
        </Link>
      </div>
    </div>
  );
}
